<template>
    <div>
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                title="Include löschen ?"
                @ok="submit" ok-text="Fortfahren" :loading="loading" :ok-disabled="includeDetailsLoading"
                @cancel="$emit('input', false)">
            Soll dieses Include <b>{{ includeName }}</b>
            wirklich gelöscht werden? <br><br>
        </Dialog>
        <Snackbar v-model="successSnackbar" color="success">Include <b>{{ includeName }}</b> erfolgreich gelöscht.
        </Snackbar>
    </div>
</template>

<script>
import Dialog from "../../../components/Dialog";
import Snackbar from "../../../components/Snackbar";

export default {
    name: "DeleteIncludeDialog",
    components: {Snackbar, Dialog},
    props: ['value', 'include', 'includeDetails', 'includeDetailsLoading'],
    data: () => {
        return {
            loading: false,
            successSnackbar: false,
        }
    },
    computed: {
        vuexState() {
            return this.$store.state.display;
        },
        selectedSite() {
            return this.vuexState.selectedSite;
        },
        includeName() {
            return this.include ? this.include.Name : ''
        }
    },
    methods: {
        async submit() {
            this.loading = true;
            try {
                let data = await this.$store.dispatch('display/deleteInclude', this.getBody());
                if (data.Status) {
                    this.successSnackbar = true;
                    this.$emit('input', false); // set v-model to false -> close dialog
                    this.$emit('deleted'); // set v-model to false -> close dialog
                }
                this.loading = false;
            } catch (e) {
                this.loading = false;
            }
        },
        getBody() {

            return {
                site_id: this.vuexState.selectedSite.SiteId,
                publisher_id: this.vuexState.selectedSite.PublisherId,
                type_id: this.vuexState.siteDetails.Current.SitetypeId,
                sitetype_include_id: this.include.Id,
                include_id: this.includeDetails.IncludeId,
                includeSiteType: this.includeDetails.IncludeSiteType,
            }
        },
    },
    watch: {}
}
</script>

<style scoped>

</style>